/**
 * Utilitários de formatação.
 */

/**
 * Formata um valor numérico como moeda BRL.
 * @param {number|string} value - Valor a ser formatado
 * @returns {string} Valor formatado como "R$ 1.234,56"
 */
export const formatCurrency = (value) => {
    const num = parseFloat(value) || 0;
    return num.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });
};
